module.exports = "/cyber/_next/static/images/cardMir-23fe515dbd17d8553fae01eed57b8bec.jpg";